import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useStorage } from './stores'
import { setAuthToken } from './stores/api/http'
import { installClientErrorReporter } from './stores/api/clientErrors'

const app = createApp(App)
const pinia = createPinia()

installClientErrorReporter()

app.use(pinia)
app.use(router)
app.mount('#app')

const store = useStorage()

function acceptUrlToken() {
  const url = new URL(window.location.href)
  const hash = new URLSearchParams(url.hash.replace(/^#/, ''))
  const token = url.searchParams.get('token') || hash.get('token')
  if (!token) return

  setAuthToken(token)
  url.searchParams.delete('token')
  hash.delete('token')
  url.hash = hash.toString()
  window.history.replaceState({}, document.title, url.toString())
}

async function init() {
  acceptUrlToken()

  await router.isReady()

  const isAuth = await store.check()

  if (isAuth) {
    await store.live()
  }
}

init().catch(err => {
  console.error('Initialization failed:', err)
})
